/**
 * Shown when Google returned an account other than the one this device's data
 * belongs to. Syncing is blocked until the user chooses, so one account's data
 * can never end up in another account's Drive.
 */
import { useState } from 'react'
import { Dialog } from './Dialog.tsx'
import { useAuth } from '../../hooks/useAuth.tsx'
import { useDB } from '../../hooks/useDB.tsx'
import { useI18n } from '../../lib/i18n/i18n-store.ts'
import { authSession } from '../../lib/auth/index.ts'
import { wipeLocalData } from '../../lib/local/wipe.ts'

export function AccountMismatchDialog() {
  const { status, pendingUser } = useAuth()
  const { services } = useDB()
  const { t } = useI18n()
  const [busy, setBusy] = useState(false)

  if (status !== 'account_mismatch' || !pendingUser) return null
  const owner = authSession.ownerEmail ?? ''
  const other = pendingUser.email

  const switchAccount = async () => {
    setBusy(true)
    await wipeLocalData(services)
    authSession.acceptPendingAccount()
    window.location.reload()
  }

  return (
    <Dialog
      title={t('account.mismatch.title')}
      onDismiss={() => authSession.rejectPendingAccount()}
      footer={
        <>
          <button className="btn" onClick={() => authSession.rejectPendingAccount()} disabled={busy}>
            {t('account.mismatch.back', { owner })}
          </button>
          <button className="btn btn--danger" onClick={() => void switchAccount()} disabled={busy}>
            {busy ? t('account.wiping') : t('account.mismatch.switch', { owner, other })}
          </button>
        </>
      }
    >
      <p>{t('account.mismatch.body', { owner, other })}</p>
    </Dialog>
  )
}
